import React from 'react'

const GeoIcon = React.lazy(() => import('./GeoIcon'))
const CalendarIcon = React.lazy(() => import('./Calendar'))

const FootPrinterIcons = {
  GeoIcon,
  CalendarIcon,
}

export default FootPrinterIcons
